<template>
  <div class="m-auto">
    <div class="d-flex mb-0 mt-0 flex-row">
      <textarea class="form-control new-comment-text-area" cols="50" rows="3" :value="value" @change="onChange" />
      <div class="d-flex flex-row">
        <div class="ml-auto mb-0" style="background: #b0c1b2">
          <a class="mx-3" @click.prevent="onSave" href="#">
            <b-badge href="#" variant="success">Save</b-badge>
          </a>
          <a class="mx-3" @click.prevent="onCancel" href="#">
            <b-badge href="#" variant="warning">Cancel</b-badge>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
    onSave: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {},
  mounted() {
    // console.log('MOUNTED Task SaveCancel')
  },
};
</script>

<style style="scss" scoped>
.new-comment-text-area {
  height: 10vh;
  text-align: justify;
  overflow: auto;
  border: solid 2px #dcf1de;
  background: transparent;
}
.form-control:focus {
  background: #dcf1de;

  border-color: #eef8ef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
.btn-primary-green {
  color: #007bff;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

a.badge-success,
a.badge-warning,
a.badge-danger {
  background: #caeacd;
  color: #203486;
}

a.badge-success:hover {
  background: #72b378;
  color: #dcf1de;
}

a.badge-warning:hover {
  background: #ad9d6c;
  color: #dcf1de;
}

a.badge-danger:hover {
  background: #bd7b79;
  color: #dcf1de;
}

a.badge-warning {
  background: #caeacd;
  color: #203486;
}

a.badge-danger {
  background: #caeacd;
  color: #203486;
}

a.badge-success:focus,
a.badge-warning:focus a.badge-danger:focus {
  background: #caeacd;
  color: #203486;
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
  font-weight: bolder;
}
</style>
